<template>
<div class="tradeCycleSiderBar">
  <VuePerfectScrollbar
    class="scroll-area--customizer"
    :settings="settings"
    :key="$vs.rtl"
  >
    <div class="content">
      <div
        class="bar-item"
        v-for="(item,index) in listData"
        :key="index"
        :class="{
          on: currentIndex  == index
        }"
        @click="barItemHandle(index)"
      >
        <div class="item-top">
          <span class="issue">{{item.issueNumber}}</span>
          <span
            :style="getStyle(item.status)"
            class="status tag-box">{{getStaus(item.status)}}</span>
        </div>
        <div class="times">
          {{$t('Management_days')}} {{item.times}}{{$t('day')}}
        </div>
      </div>
    </div>
  </VuePerfectScrollbar>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import initData2 from '@/mixins/initData';
import {getStaus, getStyle} from "@/components/user/details/mamMaster/tradingCycle/utils";
import {colorRgba} from "@/utils";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  name: "tradeCycleSiderBar",
  components: {
    VuePerfectScrollbar,
  },
  props: {
  },
  data() {
    return {
      //交易周期列表 todo,
      currentIndex: 0,//默认是选中第一个

      settings: {
        maxScrollbarLength : 60,
        wheelSpeed         : .60,
      },
      statistics:{
        userStatus: 0,
        times: 0
      },
    }
  },

  watch:{
    listRefresh(val){
      this.getData();
    }
  },
  computed:{
    ...mapGetters(['listRefresh']),
  },
  mixins: [initData2],
  mounted() {
    this.$nextTick(() => {
      this.getData();
    })
  },
  methods: {
    getStaus,
    getStyle,
    getData(){
      this.init().then((res) => {
        this.$emit('current-tradeCycle',this.listData[this.currentIndex],this.statistics);
      });
    },
    beforeInit(){
      this.params = {
        mtId: +this.$route.params.mtid,
      };
      this.url = '/crm/reception/queryMasterTradingCycles';
      return true;
    },
    barItemHandle(index){
      this.currentIndex = index;
      this.$emit('current-tradeCycle',this.listData[this.currentIndex],this.statistics);
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../../../assets/scss/variable";
.tradeCycleSiderBar {
  //需要区分pc端和移动端  todo
  //高度滑动有点问题  todo

  .bar-item {
    height: 68px;
    padding: 12px 20px;
    border-bottom: 1px solid #F4F4F4;
    cursor: pointer;
    .item-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .issue {
        color: #5E5873;
      }
      .tag-box {
        display: inline-block;
        padding-left: 15px;
        padding-right: 15px;
      }
    }
    .times {
      color: #A29FAE;
    }
    &.on {
      border-left: 4px solid $themeColor;
      .issue {
        color: $themeColor;
      }
    }
  }
}
</style>
